<template>
    <v-container fill-height v-if="loadingCI" :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-layout row justify-center align-center>
            <v-progress-circular :size="50"
                                 :width="3"
                                 color="grey"
                                 indeterminate
            ></v-progress-circular>
        </v-layout>

    </v-container>
    <v-container v-else :fullscreen="$vuetify.breakpoint.xsOnly">

        <v-layout justify-center>
            <img height="150" :src="ci.brand_configurations_ci.main_logo" alt="LOGO View">
        </v-layout>

        <v-layout row v-if="error">
            <v-flex xs12 sm6 offset-sm3 md5 offset-md4 lg4 offset-lg4 xl4 offset-xl4>
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
            </v-flex>
        </v-layout>

        <v-layout row>

            <v-flex xs12 sm6 offset-sm3 md5 offset-md4 lg4 offset-lg4 xl4 offset-xl4>
                <v-card>
                    <v-card-text>
                        <v-container id="loginForm">
                            <form @submit.prevent="onSignin">
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-text-field
                                                name="email"
                                                label="Username"
                                                placeholder="Username"
                                                id="email"
                                                v-model="email"
                                                type="email"
                                                required></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-text-field
                                                name="password"
                                                label="Password"
                                                placeholder="Password"
                                                id="password"
                                                v-model="password"
                                                type="password"
                                                required></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs12 mt-3>
                                        <v-btn color="secondary"
                                               block
                                               type="submit"
                                               :disabled="loading"
                                               :loading="loading"
                                        >
                                            Sign in
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </form>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>


    </v-container>
</template>

<script>
    import {
        Settings,
        BrandConfigurationCI
    } from '../store/namespace-helper'

    export default {
      mounted () {
        // this.getCI()
      },
      data () {
        return {
                /*          dirtyEmail: null,
                          dirtyPwd: null, */
          email: '',
          password: ''
        }
      },
        /*      mounted () {
                let times = 0
                const interval = setInterval(() => {
                  times += 1
                  if ((this.dirtyEmail && this.dirtyPwd) || times === 20) {
                    document.getElementById('loginForm').click()
                    clearInterval(interval)
                  }

        /!*          if (this.email === null || this.email === undefined || this.email === '') {
                    document.getElementById('email').placeholder = ''
                    console.log('email is not set')
                  } else {
                    document.getElementById('email').placeholder = 'Username'
                    console.log('email is set setting placeholder')
                  } *!/

                  this.dirtyEmail = document.getElementById('email')
                  this.dirtyPwd = document.getElementById('password')
                }, 200)
              }, */
      computed: {
        user () {
          return this.$store.getters.user
        },
        error () {
          return this.$store.getters.error
        },
        loading () {
          return this.$store.getters.loading
        },
        loadingCI () {
          return this.$store.getters[Settings.getters.loading]
        },
        ci () {
          let defaultTheme = this.$store.getters[BrandConfigurationCI.getters.defaultCI]
          if (defaultTheme.brand_configurations_ci.primary_color) {
            this.$vuetify.theme.primary = '#' + defaultTheme.brand_configurations_ci.primary_color
          }
          if (defaultTheme.brand_configurations_ci.secondary_color) {
            this.$vuetify.theme.secondary = '#' + defaultTheme.brand_configurations_ci.secondary_color
          }
          return defaultTheme
        }
      },
      watch: {
        user (value) {
          if (value !== null && value !== undefined) {
            this.$router.push('/')
          }
        },
        email (value) {
          if (value === null || value === undefined || value === '') {
            document.getElementById('email').removeAttribute('placeholder')
            delete document.getElementById('email').placeholder
          } else {
            document.getElementById('email').placeholder = 'Username'
          }
        },
        password (value) {
          if (value === null || value === undefined || value === '') {
            document.getElementById('password').removeAttribute('placeholder')
            delete document.getElementById('password').placeholder
          } else {
            document.getElementById('password').placeholder = 'Password'
          }
        }

      },
      methods: {
        onSignin () {
          this.$store.dispatch('signUserIn', {email: this.email, password: this.password})
        },
        onDismissed () {
          this.$store.dispatch('clearError')
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/Login.vue